import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

Alpine.data('CopyImageCarousel', () => ({
    swiperIndex: 1,
    init(){
        const swiper = new Swiper('.copyImageCarousel', {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                bulletActiveClass: 'bg-primary-900',
                bulletClass: 'w-3 h-3 border-primary-900 border-1 rounded-full cursor-pointer',
                clickable: true
            },
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 1.5
                },
                1024: {
                    slidesPerView: 1
                },
                1600: {
                    slidesPerView: 1.2
                }
            }
        });

        if (swiper) {
            swiper.on('slideChange', () => {
                this.swiperIndex = swiper.activeIndex + 1;
            });
        }
    }
}))